(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["retechart-countdown-announcement"] && !Shopify.designMode) return;
  try {
    
  const initRtaCountdown = (root) => {
    if (root.dataset.rtaInitialized === 'true') return;
    root.dataset.rtaInitialized = 'true';

    const endTime = new Date(root.dataset.endTime).getTime();
    const timer = root.querySelector('.rta-countdown-bar__timer');
    const fields = {
      days: root.querySelector('[data-days]'),
      hours: root.querySelector('[data-hours]'),
      minutes: root.querySelector('[data-minutes]'),
      seconds: root.querySelector('[data-seconds]')
    };

    if (!Number.isFinite(endTime) || !timer) {
      root.hidden = true;
      return;
    }

    let intervalId;

    const update = () => {
      if (!root.isConnected) {
        window.clearInterval(intervalId);
        return;
      }

      const remaining = endTime - Date.now();

      if (remaining <= 0) {
        window.clearInterval(intervalId);
        root.hidden = true;
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      fields.days.textContent = String(days).padStart(2, '0');
      fields.hours.textContent = String(hours).padStart(2, '0');
      fields.minutes.textContent = String(minutes).padStart(2, '0');
      fields.seconds.textContent = String(seconds).padStart(2, '0');
      timer.setAttribute('aria-label', `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`);
    };

    update();
    intervalId = window.setInterval(update, 1000);
  };

  const initAllRtaCountdowns = (scope = document) => {
    scope.querySelectorAll('[data-rta-countdown]').forEach(initRtaCountdown);
  };

  initAllRtaCountdowns();

  document.addEventListener('shopify:section:load', (event) => {
    initAllRtaCountdowns(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
